/**
 * The name of the bundled sound file which will be played when new participant
 * joins the conference.
 */
export const PARTICIPANT_JOINED_FILE = 'joined.mp3';
/**
 * The name of the bundled sound file which will be played when any participant
 * leaves the conference.
 */
export const PARTICIPANT_LEFT_FILE = 'left.wav';
/**
 * The name of the bundled sound file which will be played when any participant
 * raise an hand.
 */
export const PARTICIPANT_RAISE_HAND_FILE = 'knife-glass.mp3';
